import React from 'react'

const GiftBoxIcon = ({ color }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 11C4.55228 11 5 11.4477 5 12V21H19V12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V12C3 11.4477 3.44772 11 4 11Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 7C1 6.44772 1.44772 6 2 6H22C22.5523 6 23 6.44772 23 7V12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12V7ZM3 8V11H21V8H3Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C12.5523 6 13 6.44772 13 7V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V7C11 6.44772 11.4477 6 12 6Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 3C7.10218 3 6.72064 3.15804 6.43934 3.43934C6.15804 3.72064 6 4.10218 6 4.5C6 4.89782 6.15804 5.27936 6.43934 5.56066C6.72064 5.84196 7.10218 6 7.5 6H10.654C10.5319 5.68061 10.3774 5.32942 10.1863 4.98192C9.55732 3.83834 8.6939 3 7.5 3ZM12 7C12.9806 6.80388 12.9805 6.80354 12.9804 6.80318L12.9803 6.80236L12.9799 6.80038L12.9788 6.79503L12.9754 6.77893C12.9727 6.76583 12.9688 6.74805 12.9639 6.72588C12.954 6.68157 12.9396 6.61965 12.9203 6.54262C12.8819 6.38877 12.8237 6.17343 12.7424 5.91686C12.581 5.40732 12.3233 4.71734 11.9387 4.01808C11.1927 2.66166 9.8061 1 7.5 1C6.57174 1 5.6815 1.36875 5.02513 2.02513C4.36875 2.6815 4 3.57174 4 4.5C4 5.42826 4.36875 6.3185 5.02513 6.97487C5.6815 7.63125 6.57174 8 7.5 8H12C12.2996 8 12.5834 7.86568 12.7733 7.63399C12.9633 7.4023 13.0393 7.09766 12.9806 6.80388L12 7Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0613 4.01808C12.8073 2.66166 14.1939 1 16.5 1C17.4283 1 18.3185 1.36875 18.9749 2.02513C19.6313 2.6815 20 3.57174 20 4.5C20 5.42826 19.6313 6.3185 18.9749 6.97487C18.3185 7.63125 17.4283 8 16.5 8H12C11.7004 8 11.4166 7.86568 11.2267 7.63399C11.0367 7.4023 10.9607 7.09766 11.0194 6.80388L12 7C11.0194 6.80388 11.0195 6.80354 11.0196 6.80318L11.0197 6.80236L11.0201 6.80038L11.0212 6.79503L11.0246 6.77893C11.0274 6.76583 11.0312 6.74805 11.0361 6.72588C11.046 6.68157 11.0604 6.61965 11.0797 6.54262C11.1181 6.38877 11.1764 6.17343 11.2576 5.91686C11.419 5.40732 11.6767 4.71734 12.0613 4.01808ZM13.346 6H16.5C16.8978 6 17.2794 5.84196 17.5607 5.56066C17.842 5.27936 18 4.89782 18 4.5C18 4.10218 17.842 3.72064 17.5607 3.43934C17.2794 3.15804 16.8978 3 16.5 3C15.3061 3 14.4427 3.83834 13.8137 4.98192C13.6226 5.32942 13.4681 5.68061 13.346 6ZM12.9803 7.1978C12.9802 7.19807 12.9802 7.19804 12.9803 7.19772L12.9803 7.1978Z"
        fill={color}
      />
    </svg>
  )
}

export default GiftBoxIcon
